import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { InputText } from 'primeng/inputtext';
import { DatePicker } from 'primeng/datepicker';
import { Button } from 'primeng/button';

@Component({
    selector: 'app-dados-pessoais',
    standalone: true,
    imports: [ReactiveFormsModule, Select, InputText, DatePicker, Button],
    templateUrl: './dados-pessoais.html',
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Seção de formulário de dados pessoais. */
export class DadosPessoaisComponent {
    modoEdicao = input<boolean>(false);
    carregandoDominios = input<boolean>(false);

    opcoesGenero = input<{ label: string; value: string | number | boolean | null }[]>([]);
    opcoesEstadoCivil = input<{ label: string; value: string | number | boolean | null }[]>([]);
    opcoesSimNao = input<{ label: string; value: string | number | boolean | null }[]>([]);

    mostrarSecaoDeficiencias = input<boolean>(false);
    comDeficiencia = input<string | null>('N');
    abrirDialogDeficiencia = output<void>();
}
